<template>
  <v-container class="home-new py-4 py-md-8">
    <section class="hero-surface">
      <v-row no-gutters align="center">
        <v-col cols="12" md="7" class="pr-md-6">
          <div class="eyebrow">DISKUSIE A HLASOVANIE</div>
          <h1 class="headline-main mb-2">NONSTOPNÍK</h1>
          <p class="headline-sub mb-0">
            Vyberte si tému, sledujte novinky a hlasujte v oblastiach, ktoré sú pre vás dôležité.
          </p>
        </v-col>
        <v-col cols="12" md="5" class="mt-4 mt-md-0">
          <router-link to="/clocks" class="d-block hero-clock-link">
            <v-img v-if="!$vuetify.breakpoint.smAndDown" class="blob hero-clock" height="320px" src="@/assets/fichee.svg" contain></v-img>
            <v-img v-else class="blob hero-clock" height="240px" src="@/assets/fichee.svg" contain></v-img>
          </router-link>
        </v-col>
      </v-row>
    </section>

    <v-card class="controls-panel mt-6" elevation="8">
      <v-card-text class="py-4">
        <v-row align="center">
          <v-col cols="12" md="8" lg="9">
            <v-text-field
              v-model="search"
              label="Vyhľadávanie v témach"
              prepend-inner-icon="mdi-magnify"
              clearable
              outlined
              dense
              hide-details
              class="search-input"
            />
          </v-col>

          <v-col v-if="isAuthenticated" cols="12" md="4" lg="3" class="d-flex justify-md-end justify-start">
            <v-btn
              class="favorite-filter-btn"
              :class="{ 'favorite-filter-btn--active': filter_favorite }"
              depressed
              @click="filter_favorite = !filter_favorite"
            >
              Obľúbené
              <v-icon right>{{ filter_favorite ? "mdi-star" : "mdi-star-outline" }}</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row justify="center" class="mt-5">
      <v-col cols="12" sm="8" md="6" lg="5" class="d-flex">
        <v-card class="news-card flex-grow-1" to="/news" hover>
          <v-card-text class="d-flex align-center py-6">
            <div class="news-icon-wrap mr-4">
              <v-icon color="white" size="26">mdi-newspaper-variant-outline</v-icon>
            </div>
            <div class="flex-grow-1">
              <div class="text-overline font-weight-bold news-overline">Aktuality</div>
              <div class="text-h4 font-weight-medium">Novinky</div>
            </div>
            <v-icon color="primary">mdi-arrow-right</v-icon>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="homeTiles.length > 0" class="mt-2">
      <v-col v-for="tile in homeTiles" :key="tile.id" cols="12" sm="6" md="4" class="d-flex">
        <v-card
          class="topic-card flex-grow-1"
          :color="tile.color"
          dark
          hover
          :to="getLink(tile)"
        >
          <v-card-text class="topic-content pa-4 d-flex flex-column fill-height">
            <div class="d-flex justify-space-between align-center">
              <div class="d-flex align-center">
                <v-icon v-if="tile.icon" class="topic-icon mr-2">{{ tile.icon }}</v-icon>
              </div>

              <v-tooltip v-if="isAuthenticated" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="amber darken-2"
                    v-bind="attrs"
                    v-on="on"
                    @click.prevent="tile.user_favorite ? removeFavorite(tile.id) : addFavorite(tile.id)"
                  >
                    <v-icon>{{ tile.user_favorite ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                  </v-btn>
                </template>
                <span>{{ tile.user_favorite ? "Zrušiť obľúbené" : "Pridať obľúbené" }}</span>
              </v-tooltip>
            </div>

            <div class="topic-title text-h6 font-weight-bold mt-5">
              {{ tile.short_title }}
            </div>

            <div class="d-flex justify-space-between align-end mt-auto pt-4">
              <v-chip
                v-if="tile.private"
                x-small
                outlined
                dark
                label
                class="topic-chip"
              >
                <v-icon x-small left>mdi-file-hidden</v-icon>
                Súkromná
              </v-chip>
              <span v-else></span>

              <div v-show="tile.not_voted_questions_count > 0" class="pending-count">
                {{ tile.not_voted_questions_count }} čaká
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import { mapGetters } from "vuex";
import { APIService } from "@/http/APIService.js";

const apiService = new APIService();
export default {
  name: "Home",

  components: {
  },

  data() {
    return {
      homeTiles: [],
      search: "",
      sort: ["order"],
      count: 0,
      filter_favorite: false,
      timeout: undefined
    }
  },

  mounted: function () {
    this.getVerified();
    this.getHomeTiles();
    this.$store.dispatch("menu/fetchMenuPoll");
    this.$store.dispatch("menu/fetchMenu");
    this.$store.dispatch("settings/fetchSettings");
    if (this.isAuthenticated && this.isStaff) {
      this.$store.dispatch("menu/fetchAdminNewQuestions");
    }

  },


  watch: {
    filter_favorite() {
      this.getHomeTiles();
    },

    search() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        this.getHomeTiles();
      }, 500);
    },
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated", "isStaff", "username"]),
    ...mapGetters("settings", ["getSettings"]),
  },

  methods: {
    removeFavorite(id) {
      apiService.generalPollCategoryRemoveFavorite(id).then(() => {
        this.getHomeTiles();
      });
    },

    addFavorite(id) {
      apiService.generalPollCategoryAddFavorite(id).then(() => {
        this.getHomeTiles();
      });
    },

    getLink(item) {
      if (item.url)
        return item.url;
      else {
        return `/poll_category/${item.id}/`;
      }
    },

    getHomeTiles() {
      let limit = 0;
      let offset = 0;
      let filters = [];

      if (this.filter_favorite)
        filters.push(['favorite', 1]);

      apiService.getGeneralPollCategories(this.sort, this.search, limit, offset, filters).then((response) => {

        this.homeTiles = response.results;
        this.count = response.count;
      });
    },
    getHeight() {
      return this.getSettings.homepage_vyska + "px";
    },
    getVerified() {
      if (this.isAuthenticated) {
        apiService.getMe().then((response) => {
          this.$store.commit("auth/verified", response.verified);
          this.$store.commit("auth/verified_sms_email", response.verified_sms_email);
          this.$store.commit("auth/verified_bank", response.verified_bank);
          this.$store.commit("auth/staff", response.is_staff);
          this.$store.commit("auth/moderator", response.moderator);
          this.$store.commit("auth/setMemberStatus", response.member_status);
          this.$store.commit("auth/setFirstName", response.first_name);
          this.$store.commit("auth/setLastName", response.last_name);
          this.$store.commit("auth/setGender", response.gender);
          this.$store.commit("auth/user_id", response.id);

        });
      }
    },
  },
};
</script>

<style scoped>
.home-new {
  max-width: 1440px;
  --surface-bg: #f4f7fb;
  --surface-card: #ffffff;
  --surface-border: #dbe4ef;
  --text-strong: #132236;
  --text-soft: #4d5f76;
}

.hero-surface {
  border-radius: 24px;
  padding: 26px 24px;
  background:
    radial-gradient(circle at top right, rgba(23, 123, 255, 0.16), transparent 58%),
    radial-gradient(circle at bottom left, rgba(255, 190, 54, 0.2), transparent 50%),
    var(--surface-card);
  border: 1px solid var(--surface-border);
}

.eyebrow {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.18em;
  color: #2d6ad8;
}

.headline-main {
  font-size: clamp(2rem, 2.5vw, 2.7rem);
  line-height: 1.05;
  color: var(--text-strong);
}

.headline-sub {
  max-width: 560px;
  color: var(--text-soft);
  font-size: 1rem;
  line-height: 1.55;
}

.hero-clock {
  border-radius: 18px;
  filter: drop-shadow(0 12px 24px rgba(22, 34, 49, 0.15));
}

.hero-clock :deep(.v-image__image) {
  background-size: contain !important;
  background-position: center center !important;
}

.hero-clock-link {
  transition: transform 0.2s ease;
}

.hero-clock-link:hover {
  transform: translateY(-2px);
}

.blob {
  animation: pulse 1.2s infinite;
}

.controls-panel {
  border-radius: 18px;
  background: var(--surface-card);
  border: 1px solid var(--surface-border);
}

.favorite-filter-btn {
  min-width: 150px;
  font-weight: 700;
  border-radius: 12px;
  color: #8b5200;
  background: #fff4dc !important;
}

.favorite-filter-btn--active {
  color: #ffffff;
  background: linear-gradient(120deg, #f2a106 0%, #c77a00 100%) !important;
}

.news-card {
  border-radius: 18px;
  border: 1px solid #d5e2f0;
  background: linear-gradient(180deg, #ffffff 0%, #eff5ff 100%);
}

.news-icon-wrap {
  width: 50px;
  height: 50px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  background: linear-gradient(130deg, #1754c8 0%, #3579ff 100%);
}

.news-overline {
  color: #2f62c8 !important;
  letter-spacing: 0.08em;
}

.topic-card {
  position: relative;
  overflow: hidden;
  min-height: 192px;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(13, 24, 38, 0.2) !important;
  isolation: isolate;
}

.topic-card::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  background:
    radial-gradient(circle at 14% 12%, rgba(255, 255, 255, 0.24), transparent 36%),
    radial-gradient(circle at 86% 88%, rgba(0, 0, 0, 0.16), transparent 42%);
  pointer-events: none;
}

.topic-card::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  background: linear-gradient(
    165deg,
    rgba(255, 255, 255, 0.05) 0%,
    rgba(255, 255, 255, 0.01) 35%,
    rgba(0, 0, 0, 0.2) 100%
  );
  pointer-events: none;
}

.topic-content {
  position: relative;
  z-index: 1;
  backdrop-filter: saturate(1.05);
}

.topic-icon {
  opacity: 1;
  color: #ffffff !important;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.35));
}

.topic-title {
  color: #ffffff !important;
  line-height: 1.3;
  word-break: break-word;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.45);
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.36) 0%, rgba(0, 0, 0, 0.15) 70%, rgba(0, 0, 0, 0) 100%);
  border-radius: 10px;
  padding: 10px 12px;
}

.topic-chip {
  color: #ffffff !important;
  border-color: rgba(255, 255, 255, 0.72) !important;
  background-color: rgba(0, 0, 0, 0.24) !important;
}

.pending-count {
  color: #ffffff !important;
  font-size: 0.92rem;
  font-weight: 700;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.45);
  background: rgba(0, 0, 0, 0.3);
  border-radius: 999px;
  padding: 4px 10px;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  15% {
    transform: scale(1.15);
  }

  30% {
    transform: scale(1);
  }

  40% {
    transform: scale(1.1);
  }

  80% {
    transform: scale(1);
  }
}

@media (max-width: 960px) {
  .hero-surface {
    padding: 20px 16px;
    border-radius: 18px;
  }
}

@media (max-width: 600px) {
  .topic-card {
    min-height: 170px;
  }
}
</style>



